module.exports = __webpack_public_path__ + "static/AI-7d637ac1397c1da758924a31ea96c8a3.jpg";